import EtatReglementsController from './etat.reglements.controller';

export default {
    template: require('./etat.reglements.html'),
    controller: EtatReglementsController
};
